import { CallApi } from "app/_helpers/CallApi/CallApi";

export async function getHelpManual(data) {
  let url = "/global-configuration/ehs-module/help-manual";
  return await CallApi(url, "GET", data);
}

export async function addHelpManual(data) {
  let url = "/global-configuration/ehs-module/help-manual/add";
  return await CallApi(url, "POST", data);
}
export async function getoneHelpManual(id, data) {
  let url = "/global-configuration/ehs-module/help-manual/get/" + id;
  return await CallApi(url, "GET", data);
}
export async function updateHelpManual(id, data) {
  let url = "/global-configuration/ehs-module/help-manual/update/" + id;
  return await CallApi(url, "PUT", data);
}
export async function deleteHelpManual(id, data) {
  let url = "/global-configuration/ehs-module/help-manual/" + id;
  return await CallApi(url, "DELETE", data);
}
export async function getTitlePdf(data) {
  let url = "/global-configuration/ehs-module/help-manual/pdf/title";
  return await CallApi(url, "GET", data);
}
